export default __webpack_public_path__ + "static/media/01_DAIF_Data_04_06.2c7c96a0.mp4";